import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "USER", {
  TEXT: "User created succesfully",
  DELETE: "User deleted succesfully",
});
